import React, { useState } from 'react'
import { Button } from '@material-ui/core'
import PropTypes from 'prop-types'

import ChangeStatusCategoryDialog from '../ChangeStatusCategoryDialog'

const ChangeStatusCategoryButton = ({ category, onRefresh }) => {
  const [dialogOpen, setDialogOpen] = useState(false)

  const isActive = category.active !== false
  const actionText = isActive ? 'Inativar' : 'Ativar'

  const handleActionClick = (e) => {
    e.preventDefault()
    setDialogOpen(true)
  }

  return (
    <>
      <Button
        color="secondary"
        onClick={handleActionClick}
        fullWidth
        size="small"
      >
        {actionText}
      </Button>

      <ChangeStatusCategoryDialog
        open={dialogOpen}
        setOpen={setDialogOpen}
        category={category}
        onRefresh={onRefresh}
      />
    </>
  )
}

ChangeStatusCategoryButton.propTypes = {
  category: PropTypes.object.isRequired,
  onRefresh: PropTypes.func.isRequired,
}

export default ChangeStatusCategoryButton
